import nitesh from "../assets/team/nitesh.jpg";
import rohini from "../assets/team/rohini.jpg";
import ankit from "../assets/team/ankit.jpg";
import dilip from "../assets/team/dilip.png";
import dinesh from "../assets/team/dinesh.jpg";
import pankaj from "../assets/team/pankaj.png";
import vikash from "../assets/team/vikash.jpeg";
import anjani from "../assets/team/anjani.jpeg";
import tushar from "../assets/team/tushar.jpeg";
import manisha from "../assets/team/manisha.png";
import kamlesh from "../assets/team/kamlesh.png";
import mukesh from "../assets/team/mukesh.png";
import img1 from "../assets/team/img1.jpg";
import img2 from "../assets/team/img2.jpg";
import img3 from "../assets/team/img3.jpg";
import img4 from "../assets/team/img4.jpg";
import img5 from "../assets/team/img5.jpg";
import hardik from "../assets/team/hardik.png";
import img8 from "../assets/team/img8.jpg";
import img9 from "../assets/team/img9.jpg";
import img10 from "../assets/team/img10.jpg";
import logo from "../assets/other/logo.png";
import img11 from "../assets/team/img11.jpg";
import bitwise from "../assets/other/bitwise.jpg";
import bkl from "../assets/other/bkl.svg";
import uesio from "../assets/other/uesio.svg";
import Tushar from "../assets/team/Tushar.jpg";
import img13 from "../assets/team/img13.jpg";
import stripe from "../assets/other/stripe.png"
import paypal from "../assets/other/paypal.png"
import openai from "../assets/other/openai.png"


export const TEAM_IMAGES = {
  nitesh,
  rohini,
  ankit,
  dilip,
  dinesh,
  pankaj,
  vikash,
  anjani,
  tushar,
  manisha,
  kamlesh,
  mukesh,
  img1,
  img2,
  img3,
  img4,
  img5,
  img8,
  img9,
  img10,
  logo,
  img11,
  bitwise,
  bkl,
  uesio,
  Tushar,
  img13,
  stripe,
  paypal,
  openai,
  hardik
};
